import { createArrayLocalStorage, LocalStorageKeys } from "core/services/local-storage-service";

const lsAppErrors = createArrayLocalStorage(
    LocalStorageKeys.AppErrors,
    30,
    (existing, incoming) => existing.uuid === incoming.uuid
);

const LocalErrorsStorage = {};

LocalErrorsStorage.save = function(app, errors) {
    lsAppErrors.push({ uuid: app.uuid, errors: errors });
};

LocalErrorsStorage.load = function(app) {
    const entry = lsAppErrors.getValue().find(e => e.uuid === app.uuid);
    return entry ? entry.errors || [] : [];
};

LocalErrorsStorage.clear = function(app) {
    lsAppErrors.remove(e => e.uuid === app.uuid);
};

LocalErrorsStorage.isEmpty = function(app) {
    const entry = lsAppErrors.getValue().find(e => e.uuid === app.uuid);
    return !entry || !entry.errors || entry.errors.length === 0;
};

export default LocalErrorsStorage;
